module.exports = __webpack_public_path__ + "static/media/1471798_593947460659474_319071587_n.01c0eb97.jpg";